
// ~/stores/cartStore.js
import { defineStore } from "pinia";
//import { useAuthStore } from "~/stores/authStore";

export const useCartStore = defineStore("cart", {
  state: () => ({
    items: [], // Contenu du panier
     shippingOption: "standard", // "standard" | "express"
  }),

  getters: {
    // Nombre total d'articles dans le panier
   totalPrice: (state) =>
  state.items.reduce((sum, item) => {
    const unit = Number(item?.promo_price ?? item?.price ?? 0);
    const qty  = Number(item?.quantity ?? 1);
    return sum + unit * qty;
  }, 0),

    // Détection si le panier contient un produit nécessitant une livraison
   cartCount: (state) =>
  (Array.isArray(state.items) ? state.items : [])
    .filter(Boolean)
    .reduce((s, it) => s + Number(it?.quantity ?? 0), 0),

requiresShipping: (state) =>
  (Array.isArray(state.items) ? state.items : [])
    .filter(Boolean)
    .some((it) => Number(it?.requires_shipping) === 1),

    // Frais fixes par commande : 5€ standard ou 10€ express
    shippingCost: (state) => {
      if (!state.items.some(item => item.requires_shipping === 1)) {
        return 0;
      }
      return state.shippingOption === "express" ? 10 : 5;
    },
    
  },

  actions: {
    // Récupérer le panier depuis le serveur

    async setCart() {
      if (import.meta.env.SSR) return;
      const { useAuthStore } = await import("~/stores/authStore");
      const authStore = useAuthStore();
      // S’assurer que la session est bien chargée

      if (!import.meta.env.SSR && !authStore.isRestored) {
        // appel RESTORE UNIQUEMENT en client-side
        await authStore.restoreAuth();
      }

      try {
        if (authStore.isLoggedIn) {
          const response = await $fetch("/api/cart", {
            method: "GET",
            credentials: "include",
          });

          if (response.success) {
            this.setCartItems(response.cart);
           if (process.client && typeof localStorage !== "undefined") {
             localStorage.removeItem("guestCart"); // ✅ Supprimer le panier invité si fusion
           }
          } else {
            throw new Error(response.message || "Erreur serveur panier.");
          }
       } else {
  // 🧠 Visiteur non connecté → lire depuis localStorage
  const raw = (process.client && typeof localStorage !== "undefined")
    ? JSON.parse(localStorage.getItem("guestCart") || "[]")
    : [];

  // Migration/normalisation des anciennes formes (IDs nus, null, etc.)
  const guestCart = (Array.isArray(raw) ? raw : [])
    .filter((x) => x !== null && x !== undefined)
    .map((x) => {
      if (x && typeof x === "object") return x;
      // ex: 12 → { product_id: 12, quantity: 1 }
      const pid = Number(x);
      return Number.isFinite(pid) ? { product_id: pid, quantity: 1 } : null;
    })
    .filter((x) => x && Number.isFinite(Number(x.product_id)));

  this.setCartItems(guestCart);
}

      } catch (error) {
        console.error("Erreur lors du chargement du panier :", error);
      }
    },
    /**
     * Met à jour le mode de livraison (standard | express)
     */
    setShippingOption(option) {
      if (option === "standard" || option === "express") {
        this.shippingOption = option;
      }
    },
    // Enrichir et transformer les articles du panier
    /*async setCartItems(cartItems) {
      const { useAuthStore } = await import("~/stores/authStore");
      const authStore = useAuthStore();

      this.items = cartItems.map((item) => ({
        ...item,
        author_id: item.author_id || null,
        author_email: item.author_email || "email_auteur@inconnu.com",
        instructor_email: item.instructor_email || item.author_email,
        category_name: item.category_name?.trim() || "Inconnu",
        category_slug: item.category_slug || "inconnu",
        language: item.language || "Français",
        thumbnail: item.thumbnail || "/images/default-thumbnail.jpg",
        promo_price: Number(item.promo_price ?? item.price ?? 0),
      price: Number(item.price ?? 0),
        quantity: item.quantity || 1,
        clothing_size: item.clothing_size || null,
        clothing_color: item.clothing_color || null,
        clothing_material: item.clothing_material || null,
        stationery_type: item.stationery_type || null,
        craft_material: item.craft_material || null,
        book_publisher: item.book_publisher || null,
        article_video: item.article_video || null,
       // tinyint(1) → Number puis 0/1 ; évite null qui casse des tests stricts
       requires_shipping: Number(item.requires_shipping ?? 0),
        user_email: authStore.profile?.email || "email_acheteur@inconnu.com",
        user_id: authStore.profile?.user_id || null,
      }));
    },*/
async setCartItems(cartItems) {
  const { useAuthStore } = await import("~/stores/authStore");
  const authStore = useAuthStore();

  const arr = Array.isArray(cartItems) ? cartItems : [];

  this.items = arr
    .filter((raw) => raw !== null && raw !== undefined)
    .map((raw) => (raw && typeof raw === "object" ? raw : {}))
    .map((item) => {
      const catName = ((item?.category_name ?? "") + "").trim();
      return {
        ...item,
        author_id: item?.author_id ?? null,
        author_email: item?.author_email ?? "email_auteur@inconnu.com",
        instructor_email: item?.instructor_email ?? item?.author_email ?? null,
        category_name: catName || "Inconnu",
        category_slug: item?.category_slug ?? "inconnu",
        language: item?.language ?? "Français",
        thumbnail: item?.thumbnail ?? "/images/default-thumbnail.jpg",
        promo_price: Number(item?.promo_price ?? item?.price ?? 0),
        price: Number(item?.price ?? 0),
        quantity: Number(item?.quantity ?? 1) || 1,
        clothing_size: item?.clothing_size ?? null,
        clothing_color: item?.clothing_color ?? null,
        clothing_material: item?.clothing_material ?? null,
        stationery_type: item?.stationery_type ?? null,
        craft_material: item?.craft_material ?? null,
        book_publisher: item?.book_publisher ?? null,
        article_video: item?.article_video ?? null,
        requires_shipping: Number(item?.requires_shipping ?? 0),
        user_email: authStore.profile?.email ?? "email_acheteur@inconnu.com",
        user_id: authStore.profile?.user_id ?? null,
      };
    });
}
,
    async addToCart(product, quantity = 1) {
      const { useAuthStore } = await import("~/stores/authStore");
      const authStore = useAuthStore();

      // Si tu passes un objet complet (ex : { product_id:..., ... })
      const isObject = typeof product === "object" && product !== null;
      const pid = isObject ? product.product_id : product;

      if (!authStore.isLoggedIn) {
        try {
         const guestCart = (process.client && typeof localStorage !== "undefined")
          ? JSON.parse(localStorage.getItem("guestCart") || "[]")
           : [];
          const existingItem = guestCart.find(
            (item) => item.product_id === pid
          );
          if (existingItem) {
            existingItem.quantity += quantity;
          } else {
            // Ajoute toutes les infos si objet, sinon juste l’id/quantité
            guestCart.push(
              isObject
                ? { ...product, quantity }
                : { product_id: pid, quantity }
            );
          }
          if (process.client && typeof localStorage !== "undefined") {
           localStorage.setItem("guestCart", JSON.stringify(guestCart));
         }
          this.setCartItems(guestCart);
        } catch (e) {
          console.error("Erreur guest cart", e);
        }
        return;
      }
      // (La partie connectée ne change pas)
      try {
        const response = await $fetch("/api/cart", {
          method: "POST",
          credentials: "include",
          body: { productId: pid, quantity },
        });

        if (response.success) {
          this.setCartItems(response.cart);
        } else {
          throw new Error(
            response.message || "Erreur lors de l'ajout au panier."
          );
        }
      } catch (error) {
        console.error("Erreur lors de l'ajout au panier :", error);
      }
    },

    async checkoutNow(productId, quantity = 1) {
      await this.clearCart();
      await this.addToCart(productId, quantity);
    },
    async removeFromCart(productId) {
      const { useAuthStore } = await import("~/stores/authStore");
      const authStore = useAuthStore();
      if (!authStore.isLoggedIn) {
        // guest → localStorage
         const guest = (process.client && typeof localStorage !== "undefined")
         ? JSON.parse(localStorage.getItem("guestCart") || "[]").filter((i) => i.product_id !== productId)
         : [];
       if (process.client && typeof localStorage !== "undefined") {
         localStorage.setItem("guestCart", JSON.stringify(guest));
       }
        await this.setCartItems(guest);
        return;
      }
      // user connecté → API
      try {
        const res = await $fetch("/api/cart", {
          method: "DELETE",
          credentials: "include",
          body: { productId },
        });
        if (res.success) {
          await this.setCartItems(res.cart);
        } else {
          throw new Error(res.message || "Échec suppression");
        }
      } catch (err) {
        console.error("Erreur removeFromCart store :", err);
        throw err;
      }
    },

    // Supprimer un article du panier
    /* async removeFromCart(productId) {
      const { useAuthStore } = await import("~/stores/authStore");

      const authStore = useAuthStore();

      // ✅ Cas : utilisateur NON connecté (guestCart dans localStorage)
      if (!authStore.isLoggedIn) {
        try {
          const guestCart = JSON.parse(
            localStorage.getItem("guestCart") || "[]"
          );
          const updatedCart = guestCart.filter(
            (item) => item.product_id !== productId
          );
          localStorage.setItem("guestCart", JSON.stringify(updatedCart));
          this.setCartItems(updatedCart); // Mise à jour de l'état local
        } catch (error) {
          console.error(
            "Erreur lors de la suppression du panier invité :",
            error
          );
        }
        return;
      }

      // ✅ Cas : utilisateur connecté
      try {
        const response = await $fetch("/api/cart", {
          method: "DELETE",
          credentials: "include",
          body: { productId },
        });

        if (response.success) {
          this.setCartItems(response.cart);
        } else {
          throw new Error(
            response.message || "Erreur lors de la suppression de l'article."
          );
        }
      } catch (error) {
        console.error("Erreur lors de la suppression de l'article :", error);
      }
    },*/
    // Vider le panier
    async clearCart() {
      const { useAuthStore } = await import("~/stores/authStore");

      const authStore = useAuthStore();

      // ✅ Cas : utilisateur NON connecté → vider localStorage
      if (!authStore.isLoggedIn) {
        try {
         if (process.client && typeof localStorage !== "undefined") {
          localStorage.removeItem("guestCart");
        }
          this.items = [];
        } catch (error) {
          console.error("Erreur lors du vidage du panier invité :", error);
        }
        return;
      }

      // ✅ Cas : utilisateur connecté → appel API
      try {
        const response = await $fetch("/api/cart", {
          method: "POST",
          credentials: "include",
          body: { action: "clear" },
        });

        if (response.success) {
          this.items = [];
        } else {
          throw new Error(
            response.message || "Erreur lors du vidage du panier."
          );
        }
      } catch (error) {
        console.error("Erreur lors du vidage du panier :", error);
      }
    },
    // Incrémenter la quantité d'un produit
    async incrementQuantity(productId) {
      const { useAuthStore } = await import("~/stores/authStore");

      const authStore = useAuthStore();

      // ✅ Cas : invité
      if (!authStore.isLoggedIn) {
        try {
                  const guestCart = (process.client && typeof localStorage !== "undefined")
           ? JSON.parse(localStorage.getItem("guestCart") || "[]")
           : [];

          const item = guestCart.find((item) => item.product_id === productId);
          if (item && item.quantity < 99) {
            item.quantity += 1;
          }
          if (process.client && typeof localStorage !== "undefined") {
           localStorage.setItem("guestCart", JSON.stringify(guestCart));
         }
          this.setCartItems(guestCart);
        } catch (error) {
          console.error("Erreur lors de l'incrémentation (invité) :", error);
        }
        return;
      }

      // ✅ Cas : connecté
      try {
        const response = await $fetch("/api/cart", {
          method: "POST",
          credentials: "include",
          body: { productId, action: "increase" },
        });

        if (response.success) {
          this.setCartItems(response.cart);
        } else {
          throw new Error(
            response.message || "Erreur lors de l'augmentation de la quantité."
          );
        }
      } catch (error) {
        console.error("Erreur lors de l'augmentation de la quantité :", error);
      }
    },

    // Décrémenter la quantité d'un produit
    async decrementQuantity(productId) {
      const { useAuthStore } = await import("~/stores/authStore");

      const authStore = useAuthStore();

      // ✅ Cas : invité
      if (!authStore.isLoggedIn) {
        try {
           const guestCart = (process.client && typeof localStorage !== "undefined")
          ? JSON.parse(localStorage.getItem("guestCart") || "[]")
           : [];
          const item = guestCart.find((item) => item.product_id === productId);
          if (item && item.quantity > 1) {
            item.quantity -= 1;
          }
          if (process.client && typeof localStorage !== "undefined") {
          localStorage.setItem("guestCart", JSON.stringify(guestCart));
         }
          this.setCartItems(guestCart);
        } catch (error) {
          console.error("Erreur lors de la décrémentation (invité) :", error);
        }
        return;
      }

      // ✅ Cas : connecté
      try {
        const response = await $fetch("/api/cart", {
          method: "POST",
          credentials: "include",
          body: { productId, action: "decrease" },
        });

        if (response.success) {
          this.setCartItems(response.cart);
        } else {
          throw new Error(
            response.message || "Erreur lors de la diminution de la quantité."
          );
        }
      } catch (error) {
        console.error("Erreur lors de la diminution de la quantité :", error);
      }
    },
  },
});
